/* This component CREATES one entry for the historys collection in MongoDB.
   As the entry is being CREATED, it should then activate the HistoryRead component
   to show the entry as it is being built. */

import React, { useState }          from 'react'
import axios                        from 'axios'
import Box                          from "@material-ui/core/Box"
import {
   Button,
   Grid,
   TextField,
   TextareaAutosize,
   Typography }                     from '@material-ui/core'
import HistoryReadComponent         from './HistoryReadComponent'
import PhotoSearchComponent         from './PhotoSearchComponent'
import RadioOptionComponent         from '../Components/RadioOptionComponent'

import {
   CLIENT_PUBLIC_TOKEN,
   historyEntryTypeRadioOptions,
   historyRadioOptions
}                                   from '../config'

import { node_server }              from '../Helpers'
import GuestBioSearchComponent from './GuestBioSearchComponent'

const HistoryCreateComponent = () => {

   const [ entry,                      setEntry                      ]  =  useState('')
   const [ entryType,                  setEntryType                  ]  =  useState('')
   const [ guestBioEntry,              setGuestBioEntry              ]  =  useState(false)
   const [ historyEntry,               setHistoryEntry               ]  =  useState(false)
   const [ id,                         setId                         ]  =  useState('')
   const [ link,                       setLink                       ]  =  useState('')
   const [ linkCaption,                setLinkCaption                ]  =  useState('')
   const [ linkCollection,             setLinkCollection             ]  =  useState('')
   const [ linkType,                   setLinkType                   ]  =  useState('')
   const [ linkId,                     setLinkId                     ]  =  useState('')
   const [ photoId,                    setPhotoId                    ]  =  useState('')
   const [ showPhotoSearchComponent,   setShowPhotoSearchComponent   ]  =  useState(true)
   const [ title,                      setTitle                      ]  =  useState('')
   const [ width,                      setWidth                      ]  =  useState(0)

   const changeEntry = (e) => {
      setEntry(e.target.value)
   }

   const changeLinkCaption = (e) => {
      setLinkCaption(e.target.value)
   }

   const changeTitle = (e) => {
      setTitle(e.target.value)
   }

   const changeWidth = (e) => {
      setWidth(e.target.value)
   }

   const getOption = (o) => {
         switch (o) {
         case 'Bullet':
            setEntryType('bullet')
         break
         case 'Guest Bio Entry':
            setGuestBioEntry(true)
         break
         case 'History Entry':
            setHistoryEntry(true)
         break
         case 'Link':
            setEntryType('link')
         break
         case 'Photo':
            setEntryType('photo')
         break
         case 'Text':
            setEntryType('text')
         break
         default:
         break
      }
   }

   const handleAddPhoto = ({id, filename}) => {
      console.log('id and filename are', id, 'and', filename)
      setPhotoId(id)
      setShowPhotoSearchComponent(false)
   }

   const handleAddGuestBio = (guestBio) => {
      setLinkId(guestBio._id)
      console.log('You selected Guest Bio', guestBio)
   }

   const handleSubmitTitle = async () => {

      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      if (id === '') {
         axios.post( node_server + 'history', 
         {
            guestBioEntry,
            historyEntry,
            title
         })
         .then( res => {
            if (res.data.msg === 'good_operation') {
               console.log('res.data', res.data)
               console.log(res.data.entryToDB)
               console.log('id', res.data.entryToDB._id)
               setId(res.data.entryToDB._id)

               // handleSnackBar({ msg: 'Your photo was added!', type:'success' })
            }
            else {
               // handleSnackBar({ msg: 'No photo yet in the database.', type:'error' })
            }
         })
         .catch( ( error, msg ) => {
            console.log('error and msg are', error, msg)
         } )
      }
      else {
         axios.put((node_server + 'history'), {
            entry,
            entryType,
            guestBioEntry,
            historyEntry,
            id,
            photoId,
            width,
            link: {
               id: linkId,
               caption: linkCaption,
               collectionName: 'guestBio',
               link: ''
            }
         })
         .then( res => {
            console.log('PUT res.data is', res.data)
            if (res.data.msg === 'good_operation') {
               setEntry('')
               setLinkCaption('')
            }
         })
         .catch( ( error, msg ) => {
            console.log('error and msg are', error, msg)
         } )
      }
   }

   return (
      <Box>

         {guestBioEntry || historyEntry
            ?
               null
            :
               <Grid style={{ marginTop: '6rem' }}>
                  <RadioOptionComponent
                     getOption={getOption}
                     options={historyEntryTypeRadioOptions}
                  />
               </Grid>
         }

         {/* The HistoryRead component is needed for tests to run properly */}
         {id === ''
            ?
               null
            :
               <HistoryReadComponent id={id} />
         }

         <Grid>
            {guestBioEntry
               ?
                  <Typography variant='h5' style={{ marginTop: '6rem' }}>
                     Create a Guest Bio Entry
                  </Typography>
               :
                  null
            }
            {historyEntry
               ?
                  <Typography variant='h5' style={{ marginTop: '6rem' }}>
                     Create a Historical Entry
                  </Typography>
               :
                  null
            }
            {id === '' && ( historyEntry || guestBioEntry )
               ?
                  <Grid item xs={12} style={{ marginTop: '1rem' }} >
                     <TextField name='history-create-title' label="Title" variant='outlined' style={{ width: '90%' }} onChange={changeTitle} />
                  </Grid>
               :
                  null
            }
            {( id !== '' ) && ( historyEntry || guestBioEntry )
               ?
                  <Grid>
                     <RadioOptionComponent
                        getOption={getOption}
                        options={historyRadioOptions}
                     />
                     { entryType === 'photo' && showPhotoSearchComponent
                        ?
                           <Grid>
                              <TextField data-testid="history-create-photo-width" name='history-create-photo-width' label="Photo Width %" variant='outlined' style={{ width: '40%' }} onChange={changeWidth} />
                           </Grid>
                        :
                           null
                     }
                     { entryType === 'photo' && showPhotoSearchComponent ? <PhotoSearchComponent buttonLabel={'Add to History Entry'} handleAddPhoto={handleAddPhoto} /> : null }
                     <TextareaAutosize data-testid='history-text' label="Bullet / Link / Text" name="history-text" minRows={5} style={{ width: "90%", fontSize: "1rem" }} onChange={changeEntry} value={entry} />
                  </Grid>
               :
                  null
            }

            { entryType === 'link' ? <GuestBioSearchComponent handleAddGuestBio={handleAddGuestBio} /> : null }

            { entryType === 'link'
               ?
                  <Grid>
                     <TextField data-testid="history-create-link-caption" name='history-create-link-caption' label="Link Caption" variant='outlined' style={{ width: '40%' }} onChange={changeLinkCaption} />
                  </Grid>
               :
                  null
            }

            {title.length > 0
               ?
                  <Grid item style={{ marginTop: '1rem' }}>
                     <Button data-testid='history-create-submit' variant='contained' color='primary' onClick={handleSubmitTitle}>Submit</Button>
                  </Grid>
               :
                  <Grid item style={{ marginTop: '1rem' }}>
                     <Button variant='contained' color='primary' disabled>Submit</Button>
                  </Grid>
            }
         </Grid>

      </Box>
   )
}

export default HistoryCreateComponent
